module.exports = __webpack_public_path__ + "static/media/company-reg.ccb8c9be.jpg";